import { SITE_COL_WIDE, SITE_TABLE_COLS } from './coverage-table-grid'

const TH = 'text-[10.5px] font-bold uppercase tracking-[.06em] text-gis-heading'

/** Column header for the Sites table (Sites view only). */
export function CoverageSitesHeaderRow() {
  return (
    <div className={`${SITE_TABLE_COLS} border-b border-gis-line-2 px-3 py-[7px]`}>
      <span className={TH}>Site</span>
      <span className={`${TH} ${SITE_COL_WIDE}`}>Location</span>
      <span className={`${TH} ${SITE_COL_WIDE} text-right`}>Last survey</span>
      <span className={`${TH} ${SITE_COL_WIDE}`}>Coverage</span>
      <span className={TH}>Status</span>
      <span />
    </div>
  )
}
